var _defs, _g, _path, _g2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "95f9ee1e99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 131 322 L 234 322 L 234 374.078125 L 131 374.078125 Z M 131 322 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b127cca6bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 232 26 L 346.5 26 L 346.5 141 L 232 141 Z M 232 26 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#95f9ee1e99)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 182.441406 374.078125 C 210.738281 374.078125 233.679688 351.175781 233.742188 322.894531 C 233.742188 322.832031 233.6875 322.777344 233.625 322.777344 L 131.253906 322.777344 C 131.195312 322.777344 131.140625 322.832031 131.140625 322.894531 C 131.203125 351.175781 154.144531 374.078125 182.441406 374.078125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 302.351562 256.890625 C 296.746094 249.726562 293.699219 240.890625 293.699219 231.792969 L 293.699219 157.015625 C 292.28125 157.097656 290.855469 157.144531 289.421875 157.144531 C 248.726562 157.144531 215.738281 124.160156 215.738281 83.46875 C 215.738281 69.652344 219.546875 56.734375 226.164062 45.683594 C 218.699219 42.492188 210.820312 40.082031 202.621094 38.578125 C 202.621094 38.578125 202.621094 23.589844 202.621094 23.359375 C 202.621094 12.214844 193.585938 3.175781 182.441406 3.175781 C 171.296875 3.175781 162.261719 12.214844 162.261719 23.359375 C 162.261719 23.589844 162.261719 38.578125 162.261719 38.578125 C 110.90625 47.988281 71.882812 92.660156 71.199219 146.566406 L 71.183594 146.566406 L 71.183594 231.792969 C 71.183594 240.890625 68.136719 249.726562 62.53125 256.890625 L 32.316406 295.46875 C 28.488281 301.054688 32.488281 308.644531 39.257812 308.644531 L 325.621094 308.644531 C 332.394531 308.644531 336.394531 301.054688 332.5625 295.46875 L 302.351562 256.890625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b127cca6bc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fc9642",
    d: "M 346.839844 83.46875 C 346.839844 115.179688 321.132812 140.886719 289.421875 140.886719 C 257.707031 140.886719 232 115.179688 232 83.46875 C 232 51.753906 257.707031 26.046875 289.421875 26.046875 C 321.132812 26.046875 346.839844 51.753906 346.839844 83.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc9642",
    d: "M 288.949219 55.367188 L 276.042969 62.277344 L 278.117188 70.472656 L 287.125 65.609375 L 287.125 111.566406 L 296.800781 111.566406 L 296.800781 55.367188 L 288.949219 55.367188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.463124a1ba954d4b3008d1e314caf1ce.svg";
export { ForwardRef as ReactComponent };